/**
 * A coded message from DataLayer: job errors, plan warnings, deploy issues and
 * plan-check findings all arrive in this envelope. Field names are the wire's own
 * (`error_code`/`error_message`, camel-cased by `apiResponseCaseInterceptor`) so that
 * no layer re-spells the envelope — a `multiple_errors` child, which `details` carries
 * verbatim, then reads the same way as its parent.
 */
export interface CodedStatusMessage {
  errorCode: string;
  // TODO: ignore the message returned by the API and ask for the translation
  // before displaying
  errorMessage: string;
  details?: object;
}

/**
 * Pass to `convertKeysToCamelCase` on every transport that carries a
 * {@link CodedStatusMessage}. `details` is DataLayer's own payload, matched key-for-key
 * against the error's JSON Schema property names — both by the warning normalizer
 * (`details.context[].entity.entity_type`) and by the legacy reference table's
 * snake_case paths — so camel-casing it silently strips a warning's references.
 */
export const CODED_MESSAGE_VERBATIM_KEYS: string[] = ['details'];
